import React, { useEffect } from "react";
import styled from "styled-components";
import AttachFileIcon from 'assets/icons/attachFile.svg';
import {
    addFilesToUppy,
    uploadFilesToTransloadit,
    convertFileToDataURI
} from "utils/uppy";
import {ALLOWED_FILE_TYPES} from "../../../common/constants";
import {MAX_FILE_SIZE, MESSAGE_TYPES} from "../../containers/App/constants";
import {fileValidate} from "../../../utils/fileValidate";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useConfig } from "context";

const AttachFiles = styled.div`
  position: relative;
  margin-right: 10px;
  opacity: 80%;
  cursor: pointer;
  label {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 0;
    left: 0;
    cursor: inherit;
  }
  input {
    display: none;
  }
`;

const FileSharing = ({handleSendingMessageToPusher, Language, pushMessage, setProgressBarCompletion, removeFromConversation, setUploadErrorMessage, setPreviewRetry}) => {
    const LightTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#FFFFFF",
            border: "1px solid #A3AEBF",
            color: `rgba(0, 0, 0, 0.87)`,
            boxShadow: `0px 4px 8px 1px rgba(0, 0, 0, 0.25)`,
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '22px',
            zIndex:3141592,
        },
        [`& .${tooltipClasses.arrow}`]:{
            color: "#FFFFFF !important",
        },
        [`& .${tooltipClasses.arrow}:before`]:{
            border: "1px solid #A3AEBF",
        },
        [`&`]:{
            zIndex: "3141592 !important",
        }
    }));
  const { config } = useConfig();
  useEffect(() => {
    const fileInput = document.getElementById("attach-files");
    fileInput.addEventListener("change", getFilesHandler);
    return () => {
      fileInput.removeEventListener("change", getFilesHandler);
    };
  });

  const getFilesHandler = async (event) => {
    const files = Array.from(event?.target?.files || []);
      setUploadErrorMessage('');
      if(files.length < 1) return;
      let fileUploadError = fileValidate(files[0], Language);
      if(fileUploadError !==''){
          setUploadErrorMessage(fileUploadError);
          return;
      }
      setProgressBarCompletion(0.1);
      setUploadErrorMessage('');
      const url = await convertFileToDataURI(files[0]);
      let id = Math.random().toString(16).slice(2);
      const message = {
          img: null,
          name: null,
          lead: true,
          attachments: {
              url,
              type: `${files[0].name.split('.').pop()}`,
              name: files[0].name,
              size: files[0].size,
          },
          time: Date.now(),
          type: MESSAGE_TYPES.attachments,
          preview: true,
          id,
      };
    pushMessage({ meta: { message } });
    addFilesToUppy(files, setProgressBarCompletion, id, removeFromConversation, setUploadErrorMessage);
    uploadFilesToTransloadit({sendToPusher: meta => handleSendingMessageToPusher(meta, id)}, config, setProgressBarCompletion, setUploadErrorMessage, setPreviewRetry);
  };
  return (
    <LightTooltip
      title={(Language && Language.FileSharingMaxSize) || "Attach Files. Max size 10 MB."}
      placement="top-end"
      arrow
      componentsProps={{arrow: {backgroundColor: "red"}}}>
        <AttachFiles>
          <img src={AttachFileIcon} alt="attach files" />
          <label htmlFor="attach-files" />
          <input
            id="attach-files"
            type="file"
            multiple={false}
            accept={ALLOWED_FILE_TYPES.join(",")}
            hidden
          />
        </AttachFiles>
  </LightTooltip>
  );
};

export default FileSharing;
